import { ComponentChildren } from 'preact'
import { classnames } from '../../../utils'
import styles from './index.module.css'
import { Show } from '../../directives'

export function DrawerBottomHeader({ children }: { children: ComponentChildren }) {
  return <div class={styles.header}>{children}</div>
}

export function DrawerBottomFooter({ children }: { children: ComponentChildren }) {
  return <div class={styles.footer}>{children}</div>
}

export function DrawerBottomContent({ children }: { children: ComponentChildren }) {
  return <div class={styles.content}>{children}</div>
}

export function ArrowUp({ fill }: { fill: string }) {
  return (
    <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7592 7.65079C15.3998 8.07011 14.7685 8.11868 14.3492 7.75925L7.99998 2.31708L1.65077 7.75925C1.23145 8.11868 0.600147 8.07012 0.240725 7.65079C-0.118698 7.23146 -0.0701352 6.60016 0.349191 6.24074L7.34919 0.240741C7.72368 -0.08025 8.27628 -0.0802501 8.65077 0.240741L15.6508 6.24074C16.0701 6.60016 16.1187 7.23146 15.7592 7.65079Z"
        fill={fill}
      />
    </svg>
  )
}

export function ArrowDown({ fill }: { fill: string }) {
  return (
    <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.240762 0.349242C0.600184 -0.0700838 1.23148 -0.118645 1.65081 0.240777L8.00002 5.68296L14.3492 0.240777C14.7686 -0.118645 15.3999 -0.0700838 15.7593 0.349242C16.1187 0.768568 16.0701 1.39987 15.6508 1.75929L8.65081 7.75929C8.27632 8.08028 7.72372 8.08028 7.34923 7.75929L0.349227 1.75929C-0.0700991 1.39987 -0.118661 0.768568 0.240762 0.349242Z"
        fill={fill}
      />
    </svg>
  )
}

export function DrawerBottomSheet({
  children,
  id,
  expanded,
  visible,
  onHandleClick,
  showArrow = true,
}: {
  children: ComponentChildren
  expanded: boolean
  visible: boolean
  id: string
  onHandleClick: () => void
  showArrow: boolean
}) {
  return (
    <div
      class={classnames({
        [styles.container]: true,
        [styles.visible]: visible,
        [styles.expanded]: expanded,
      })}
      aria-expanded={expanded}
      id={id}
    >
      <div class={styles.layout}>
        <button
          disabled={!showArrow}
          type="button"
          class={classnames(styles.handle)}
          onClick={onHandleClick}
          aria-label={expanded ? 'Collapse list' : 'Expand list'}
          aria-controls={id}
        >
          <Show when={showArrow}>
            {expanded ? <ArrowDown fill="rgba(218, 225, 231, 1)" /> : <ArrowUp fill="rgba(218, 225, 231, 1)" />}
          </Show>
        </button>
        {children}
      </div>
    </div>
  )
}
